import React from 'react';
import { Button, Checkbox } from 'rsuite';
import styles from './FilterSelectAllExtraFooter.module.scss';
import { ProductDTO } from '../../types';

type FilterSelectAllExtraFooterProps = {
  indeterminate?: boolean;
  checked?: boolean;
  list?: ProductDTO[];
  buttonDisabled?: boolean;
  onChange?: (value: any, checked: boolean, event: React.SyntheticEvent) => void;
  onClick?: (event: React.SyntheticEvent) => void;
};

export const FilterSelectAllExtraFooter = ({ indeterminate, checked, list, buttonDisabled, onChange, onClick }: FilterSelectAllExtraFooterProps) => {
  return (
    <div className={styles.footer}>
      <Checkbox inline indeterminate={indeterminate} checked={checked} onChange={onChange}>
        Selecionar tudo <span>{list?.length ? `(${list.length})` : null}</span>
      </Checkbox>
      <Button appearance="ghost" onClick={onClick} disabled={buttonDisabled}>
        Carregar mais
      </Button>
    </div>
  );
};
